module.exports = __webpack_public_path__ + "static/media/icon-bin_grey.2538dbf1.svg";